import React, { useState, useContext, useEffect } from 'react'
import { ThemeProvider as ThemeStyled } from 'styled-components'
import defaultTheme from 'config/theme'

const ThemeContext = React.createContext()

function getDefaultTheme(customTheme) {
  const { whiteLogoUrl, colorLogoUrl, favicon, publicConfig } = customTheme
  const publicColors = publicConfig ? publicConfig.colors : {}
  const colors = { ...defaultTheme.colors, ...publicColors }
  return {
    whiteLogoUrl,
    colorLogoUrl,
    favicon,
    ...defaultTheme,
    ...publicConfig,
    colors,
  }
}

function ThemeProvider({ children, corporationTheme }) {
  const [theme, setTheme] = useState(getDefaultTheme(corporationTheme))
  function mergeTheme(theme) {
    setTheme({ ...defaultTheme, ...theme })
  }
  useEffect(() => {
    //Seteo de favicon del tema
    const link =
      document.querySelector(`link[rel*='icon']`) ||
      document.createElement(`link`)
    link.type = `image/x-icon`
    link.rel = `shortcut icon`
    link.href = theme.favicon
    document.getElementsByTagName(`head`)[0].appendChild(link)
  }, [theme.favicon])
  return (
    <ThemeContext.Provider value={{ theme, mergeTheme }}>
      <ThemeStyled theme={theme}>{children}</ThemeStyled>
    </ThemeContext.Provider>
  )
}

function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error(`useTheme must be used within a ThemeProvider`)
  }
  return context
}

export { ThemeProvider, useTheme }
